import React from 'react';

interface Props {
  className?: string;
}

const FileHorizontal: React.FC<Props> = ({ className = '' }: Props) => {
  return (
    <svg
      className={className}
      fill="none"
      height="24"
      viewBox="0 0 32 24"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_421_3692)">
        <path
          d="M32 24L32 10L22 10L22 -4.37114e-07L1.04907e-06 -1.39876e-06L0 24L32 24ZM24 -3.49691e-07L24 8L32 8L24 -3.49691e-07Z"
          fill="#20272E"
        />
        <path
          d="M18 8.61249L18.8125 9.75416V9.74999L23.8125 16.75L24 17.0125V17.3333V17.6667V18.6667H23H15.3333H14.3333H13H12H9H8V17.6667V17.3333V16.9542L8.25417 16.6708L10.9208 13.6708L11.6667 12.8292L12.4125 13.6667L13.5083 14.9L17.1875 9.74999L18 8.61249Z"
          fill="white"
        />
        <path
          d="M12 7.33333C12 8.43749 11.1042 9.33333 10 9.33333C8.89583 9.33333 8 8.43749 8 7.33333C8 6.22916 8.89583 5.33333 10 5.33333C11.1042 5.33333 12 6.22916 12 7.33333Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_421_3692">
          <rect
            fill="white"
            height="32"
            transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 32 24)"
            width="24"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FileHorizontal;
